import EmberRouter from '@embroider/router';
import config from 'madow-tech/config/environment';

export default class Router extends EmberRouter {
  location = config.locationType;
  rootURL = config.rootURL;
}

Router.map(function () {
  // Index route for root URL - will redirect to default locale
  this.route('index', { path: '/' });

  // Explicit locale routes: /en, /es
  this.route('en', { path: '/en' }, function () {
    this.route('index', { path: '/' });
    this.route('services', { path: '/services' }, function () {
      this.route('ember', { path: '/ember' });
    });
  });
  this.route('es', { path: '/es' }, function () {
    this.route('index', { path: '/' });
    this.route('services', { path: '/services' }, function () {
      this.route('ember', { path: '/ember' });
    });
  });

  // Contact success page - locale-agnostic, uses ember-intl for language
  this.route('contact-success', { path: '/contact-success' });

  // Wildcard route for 404 - must be last
  this.route('not-found', { path: '/*path' });
});
